@file:OptIn(org.jetbrains.compose.resources.InternalResourceApi::class)

package truematchmp.composeapp.generated.resources

import kotlin.OptIn
import org.jetbrains.compose.resources.StringResource

private object CommonMainString0 {
  public val app_name: StringResource by 
      lazy { init_app_name() }

  public val auth_error: StringResource by 
      lazy { init_auth_error() }

  public val brand_guidelines: StringResource by 
      lazy { init_brand_guidelines() }

  public val confirm: StringResource by 
      lazy { init_confirm() }

  public val facebook_login: StringResource by 
      lazy { init_facebook_login() }

  public val feedback: StringResource by 
      lazy { init_feedback() }

  public val google_login: StringResource by 
      lazy { init_google_login() }

  public val location_error: StringResource by 
      lazy { init_location_error() }

  public val location_not_supported: StringResource by 
      lazy { init_location_not_supported() }

  public val network_error: StringResource by 
      lazy { init_network_error() }

  public val privacy_policy: StringResource by 
      lazy { init_privacy_policy() }

  public val slogan_ai: StringResource by 
      lazy { init_slogan_ai() }

  public val slogan_ai_description: StringResource by 
      lazy { init_slogan_ai_description() }

  public val slogan_connect: StringResource by 
      lazy { init_slogan_connect() }

  public val slogan_connect_description: StringResource by 
      lazy { init_slogan_connect_description() }

  public val slogan_focus: StringResource by 
      lazy { init_slogan_focus() }

  public val slogan_focus_description: StringResource by 
      lazy { init_slogan_focus_description() }

  public val slogan_games: StringResource by 
      lazy { init_slogan_games() }

  public val slogan_games_description: StringResource by 
      lazy { init_slogan_games_description() }

  public val slogan_tasty_cashback: StringResource by 
      lazy { init_slogan_tasty_cashback() }

  public val slogan_tasty_cashback_description: StringResource by 
      lazy { init_slogan_tasty_cashback_description() }

  public val term_of_service: StringResource by 
      lazy { init_term_of_service() }

  public val unexpected_error: StringResource by 
      lazy { init_unexpected_error() }
}

internal val Res.string.app_name: StringResource
  get() = CommonMainString0.app_name

private fun init_app_name(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:app_name", "app_name",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/truematchmp.composeapp.generated.resources/values/strings.commonMain.cvr", 10,
    32),
    )
)

internal val Res.string.auth_error: StringResource
  get() = CommonMainString0.auth_error

private fun init_auth_error(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:auth_error", "auth_error",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/truematchmp.composeapp.generated.resources/values/error_strings.commonMain.cvr",
    10, 78),
    )
)

internal val Res.string.brand_guidelines: StringResource
  get() = CommonMainString0.brand_guidelines

private fun init_brand_guidelines(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:brand_guidelines", "brand_guidelines",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/truematchmp.composeapp.generated.resources/values/strings.commonMain.cvr", 43,
    48),
    )
)

internal val Res.string.confirm: StringResource
  get() = CommonMainString0.confirm

private fun init_confirm(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:confirm", "confirm",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/truematchmp.composeapp.generated.resources/values/strings.commonMain.cvr", 92,
    27),
    )
)

internal val Res.string.facebook_login: StringResource
  get() = CommonMainString0.facebook_login

private fun init_facebook_login(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:facebook_login", "facebook_login",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/truematchmp.composeapp.generated.resources/values/strings.commonMain.cvr",
    120, 54),
    )
)

internal val Res.string.feedback: StringResource
  get() = CommonMainString0.feedback

private fun init_feedback(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:feedback", "feedback",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/truematchmp.composeapp.generated.resources/values/strings.commonMain.cvr",
    175, 28),
    )
)

internal val Res.string.google_login: StringResource
  get() = CommonMainString0.google_login

private fun init_google_login(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:google_login", "google_login",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/truematchmp.composeapp.generated.resources/values/strings.commonMain.cvr",
    204, 48),
    )
)

internal val Res.string.location_error: StringResource
  get() = CommonMainString0.location_error

private fun init_location_error(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:location_error", "location_error",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/truematchmp.composeapp.generated.resources/values/error_strings.commonMain.cvr",
    89, 74),
    )
)

internal val Res.string.location_not_supported: StringResource
  get() = CommonMainString0.location_not_supported

private fun init_location_not_supported(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:location_not_supported", "location_not_supported",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/truematchmp.composeapp.generated.resources/values/error_strings.commonMain.cvr",
    164, 78),
    )
)

internal val Res.string.network_error: StringResource
  get() = CommonMainString0.network_error

private fun init_network_error(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:network_error", "network_error",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/truematchmp.composeapp.generated.resources/values/error_strings.commonMain.cvr",
    243, 73),
    )
)

internal val Res.string.privacy_policy: StringResource
  get() = CommonMainString0.privacy_policy

private fun init_privacy_policy(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:privacy_policy", "privacy_policy",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/truematchmp.composeapp.generated.resources/values/strings.commonMain.cvr",
    253, 42),
    )
)

internal val Res.string.slogan_ai: StringResource
  get() = CommonMainString0.slogan_ai

private fun init_slogan_ai(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:slogan_ai", "slogan_ai",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/truematchmp.composeapp.generated.resources/values/strings.commonMain.cvr",
    490, 29),
    )
)

internal val Res.string.slogan_ai_description: StringResource
  get() = CommonMainString0.slogan_ai_description

private fun init_slogan_ai_description(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:slogan_ai_description", "slogan_ai_description",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/truematchmp.composeapp.generated.resources/values/strings.commonMain.cvr",
    296, 193),
    )
)

internal val Res.string.slogan_connect: StringResource
  get() = CommonMainString0.slogan_connect

private fun init_slogan_connect(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:slogan_connect", "slogan_connect",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/truematchmp.composeapp.generated.resources/values/strings.commonMain.cvr",
    607, 50),
    )
)

internal val Res.string.slogan_connect_description: StringResource
  get() = CommonMainString0.slogan_connect_description

private fun init_slogan_connect_description(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:slogan_connect_description", "slogan_connect_description",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/truematchmp.composeapp.generated.resources/values/strings.commonMain.cvr",
    520, 86),
    )
)

internal val Res.string.slogan_focus: StringResource
  get() = CommonMainString0.slogan_focus

private fun init_slogan_focus(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:slogan_focus", "slogan_focus",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/truematchmp.composeapp.generated.resources/values/strings.commonMain.cvr",
    759, 52),
    )
)

internal val Res.string.slogan_focus_description: StringResource
  get() = CommonMainString0.slogan_focus_description

private fun init_slogan_focus_description(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:slogan_focus_description", "slogan_focus_description",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/truematchmp.composeapp.generated.resources/values/strings.commonMain.cvr",
    658, 100),
    )
)

internal val Res.string.slogan_games: StringResource
  get() = CommonMainString0.slogan_games

private fun init_slogan_games(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:slogan_games", "slogan_games",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/truematchmp.composeapp.generated.resources/values/strings.commonMain.cvr",
    977, 48),
    )
)

internal val Res.string.slogan_games_description: StringResource
  get() = CommonMainString0.slogan_games_description

private fun init_slogan_games_description(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:slogan_games_description", "slogan_games_description",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/truematchmp.composeapp.generated.resources/values/strings.commonMain.cvr",
    812, 164),
    )
)

internal val Res.string.slogan_tasty_cashback: StringResource
  get() = CommonMainString0.slogan_tasty_cashback

private fun init_slogan_tasty_cashback(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:slogan_tasty_cashback", "slogan_tasty_cashback",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/truematchmp.composeapp.generated.resources/values/strings.commonMain.cvr",
    1164, 49),
    )
)

internal val Res.string.slogan_tasty_cashback_description: StringResource
  get() = CommonMainString0.slogan_tasty_cashback_description

private fun init_slogan_tasty_cashback_description(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:slogan_tasty_cashback_description", "slogan_tasty_cashback_description",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/truematchmp.composeapp.generated.resources/values/strings.commonMain.cvr",
    1026, 137),
    )
)

internal val Res.string.term_of_service: StringResource
  get() = CommonMainString0.term_of_service

private fun init_term_of_service(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:term_of_service", "term_of_service",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/truematchmp.composeapp.generated.resources/values/strings.commonMain.cvr",
    1214, 47),
    )
)

internal val Res.string.unexpected_error: StringResource
  get() = CommonMainString0.unexpected_error

private fun init_unexpected_error(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:unexpected_error", "unexpected_error",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/truematchmp.composeapp.generated.resources/values/error_strings.commonMain.cvr",
    317, 80),
    )
)
